module.exports = __webpack_public_path__ + "img/banner.ab4e2dc6.jpg";